const MAX_ENTRIES = 500;

type CachedHeights = Record<string, number>;

function createHeightCache(storageKey: string) {
  let _cache: CachedHeights | null = null;

  function load(): CachedHeights {
    if (_cache !== null) return _cache;
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        _cache = JSON.parse(stored);
        return _cache!;
      }
    } catch { /* ignore */ }
    _cache = {};
    return _cache;
  }

  function save(): void {
    if (_cache === null) return;
    try {
      const entries = Object.entries(_cache);
      if (entries.length > MAX_ENTRIES) {
        _cache = Object.fromEntries(entries.slice(-MAX_ENTRIES));
      }
      localStorage.setItem(storageKey, JSON.stringify(_cache));
    } catch { /* ignore */ }
  }

  return {
    get(id: string): number | undefined { return load()[id]; },
    set(id: string, height: number): void { load()[id] = height; save(); },
    getAll(): ReadonlyMap<string, number> { return new Map(Object.entries(load())); },
  };
}

const _rowHeights = createHeightCache('component-explorer:fixtureHeights');
const _contentHeights = createHeightCache('component-explorer:fixtureContentHeights');

export function setCachedHeight(fixtureId: string, height: number): void { _rowHeights.set(fixtureId, height); }
export function getCachedHeight(fixtureId: string): number | undefined { return _rowHeights.get(fixtureId); }
export function getAllCachedHeights(): ReadonlyMap<string, number> { return _rowHeights.getAll(); }

export function setCachedContentHeight(fixtureId: string, height: number): void { _contentHeights.set(fixtureId, height); }
export function getCachedContentHeight(fixtureId: string): number | undefined { return _contentHeights.get(fixtureId); }
